/**
 * Login / Register Popup Module
 * HTML is rendered by PHP in wp_footer (guests only), JS handles views, register steps and AJAX
 */
import popups from "./motion/popups";

const loginPopup = {
    init() {
        // Ten sam widok dziala jako modal w stopce i jako formularz wbudowany
        // w strone konta / rejestracji. Wbudowany ma pierwszenstwo - jesli jest
        // na stronie, modalu i tak nie ma (PHP go nie renderuje).
        const $inline = $('.login-popup-inline');

        this.isModal = !$inline.length;
        this.$overlay = this.isModal ? $('.login-popup-overlay') : $inline;

        if (!this.$overlay.length) {
            return;
        }

        this.$popup = this.$overlay.find('.login-popup');
        this.$registerForm = this.$overlay.find('.login-popup__form--register');
        this.bindEvents();
    },

    bindEvents() {
        const self = this;

        if (this.isModal) {
            $(document).on('click', '.btn-login-account, [data-login-popup-open]', function(e) {
                e.preventDefault();
                self.open($(this).data('login-popup-open') || 'login');
            });

            $(document).on('keydown', '[data-login-popup-open][role="button"]', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    self.open($(this).data('login-popup-open') || 'login');
                }
            });

            // Other links to the account page (menu "Moje konto", register page...) - after login go to the link target.
            // Password reset stays a normal page.
            $(document).on('click', 'a[href*="/my-account"]:not(.btn-login-account)', function(e) {
                if ($(this).closest('.login-popup-overlay').length || /lost-password/.test(this.href) || e.ctrlKey || e.metaKey) {
                    return;
                }
                e.preventDefault();
                self.open('login', this.href);
            });

            this.$overlay.on('click', '[data-login-popup-close]', function(e) {
                e.preventDefault();
                self.close();
            });

            // Close on overlay click
            this.$overlay.on('click', function(e) {
                if (e.target === self.$overlay[0]) {
                    self.close();
                }
            });

            // Close on ESC key
            $(document).on('keyup', function(e) {
                if (e.key === 'Escape' && self.$overlay.hasClass('active')) {
                    self.close();
                }
            });
        }

        // AI assistant - without a configured URL notify the assistant widget via event
        this.$overlay.on('click', '[data-assistant-open]', function(e) {
            if ($(this).attr('href') !== '#') {
                return;
            }
            e.preventDefault();
            self.close();
            $(document).trigger('ecotex:assistant-open');
        });

        // Switch login <-> register (after registration the user is already logged in - go to the shop)
        this.$overlay.on('click', '[data-login-popup-view]', function(e) {
            e.preventDefault();
            if (self.redirect) {
                window.location.href = self.redirect;
                return;
            }
            self.setView($(this).data('login-popup-view'));
        });

        this.$overlay.on('click', '[data-register-continue]', function(e) {
            e.preventDefault();
            window.location.href = self.redirect;
        });

        this.$overlay.on('click', '[data-register-next]', function(e) {
            e.preventDefault();
            if (self.validate(self.$registerForm.find('[data-register-step="1"]'))) {
                self.setStep(2);
            }
        });

        this.$overlay.on('click', '[data-register-back]', function(e) {
            e.preventDefault();
            self.setStep(1);
        });

        // Enter in step 1 goes to the next step instead of submitting the whole form
        this.$registerForm.on('keydown', '[data-register-step="1"] input', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                self.$registerForm.find('[data-register-next]').trigger('click');
            }
        });

        this.$overlay.on('submit', '.login-popup__form--login', function(e) {
            e.preventDefault();
            if (!self.validate($(this))) {
                return;
            }
            self.send($(this), function() {
                if (self.target) {
                    window.location.href = self.target;
                } else {
                    window.location.reload();
                }
            });
        });

        this.$registerForm.on('submit', function(e) {
            e.preventDefault();
            self.submitRegister($(this));
        });
    },

    open(view, target) {
        this.target = target || null;
        this.$overlay.addClass('active').attr('aria-hidden', 'false');
        $('body').css('overflow', 'hidden');
        this.setView(view);
    },

    close() {
        if (!this.isModal) {
            return;
        }
        // Account was created in the popup - reload so the page reflects the logged-in state
        if (this.redirect) {
            window.location.reload();
            return;
        }
        popups.close(this.$overlay[0], this.$popup[0], () => {
            this.$overlay.removeClass('active').attr('aria-hidden', 'true');
            $('body').css('overflow', '');
        });
    },

    setView(view) {
        this.$popup.attr('data-view', view);
        this.$popup.find('[data-view-panel]').each(function() {
            $(this).prop('hidden', !String($(this).data('view-panel')).split(' ').includes(view));
        });
        this.hideErrors(this.$popup);

        if (view === 'register') {
            this.setStep(1);
        } else if (view === 'success') {
            this.$popup.find('[data-register-continue]').trigger('focus');
        } else {
            this.$popup.find('.login-popup__form--login input:visible').first().trigger('focus');
        }
    },

    setStep(step) {
        this.$registerForm.find('[data-register-step]').each(function() {
            $(this).prop('hidden', Number($(this).data('register-step')) !== step);
        });
        this.$registerForm.find('[data-step-dot]').each(function() {
            $(this).toggleClass('is-active', Number($(this).data('step-dot')) === step);
        });
        this.$registerForm.find(`[data-register-step="${step}"] input:visible`).first().trigger('focus');
    },

    validate($container) {
        return $container.find('input, select').toArray().every((el) => el.reportValidity());
    },

    submitRegister($form) {
        const password = $form.find('[name="password"]').val();
        const repeat = $form.find('[name="password_repeat"]')[0];

        repeat.setCustomValidity(password === repeat.value ? '' : $form.data('error-password-match'));

        if (!this.validate($form.find('[data-register-step="2"]'))) {
            return;
        }

        this.send($form, (data) => {
            this.redirect = data.redirect;
            if (!data.activated) {
                this.showPendingReview();
            }
            this.setView('success');
        }, (data) => {
            this.setStep(data.step || 2);
        });
    },

    // Account created but waiting for manual approval (company not confirmed in a register, e.g. VAT number inactive in VIES)
    showPendingReview() {
        const $continue = this.$popup.find('[data-register-continue]');

        this.$popup.find('[data-register-pending]').prop('hidden', false);
        $continue.text($continue.data('label-pending'));
    },

    send($form, onSuccess, onError) {
        const self = this;
        const $btn = $form.find('[type="submit"]');
        const defaultError = $form.data('error-default');

        this.hideErrors($form);
        $btn.prop('disabled', true).addClass('loading');

        $.post(settings.ajax_url, $form.serialize())
            .done(function(response) {
                if (response.success) {
                    onSuccess(response.data || {});
                    return;
                }
                const data = response.data || {};
                if (onError) {
                    onError(data);
                }
                self.showError($form, data.message || defaultError);
                $btn.prop('disabled', false).removeClass('loading');
            })
            .fail(function() {
                self.showError($form, defaultError);
                $btn.prop('disabled', false).removeClass('loading');
            });
    },

    showError($form, message) {
        $form.find('.login-popup__error')
            // Only the error box of the visible step (the box itself is still [hidden] here)
            .filter((i, el) => !$(el).parent().closest('[hidden]').length)
            .text(message)
            .prop('hidden', false);
    },

    hideErrors($container) {
        $container.find('.login-popup__error').prop('hidden', true).text('');
    }
};

export default loginPopup;
